<template>
<v-row class="mb-0">
  <v-col sm=2>
    <!-- Search --> 
    <v-row no-gutters>
      <v-text-field 
        v-model="search.value"
        label="Digite para pesquisar"
        outlined
        dense
        clearable
        hide-details
      >
      </v-text-field>
    </v-row>

    <!-- Limpar Filtros -->
    <v-row no-gutters>
      <v-btn class="px-0" @click="clearFilters" text small color="primary">
        <v-icon left>mdi-close</v-icon>
        Limpar Todos os Filtros
      </v-btn>
    </v-row>
  </v-col>

  <!-- Filters -->
  <v-col 
    sm=auto
    v-for="filter in filters"
    :key="filter.value"
    >
    <v-switch
      v-if="filter.filterType == 'switch'"
      v-model="filtersModels[filter.value]"
      :label="filter.filterLabel || filter.text"
      dense
      inset
      class="pa-0 ma-0 pt-2"
    ></v-switch>
    <v-select
      v-else
      v-model="filtersModels[filter.value]"
      :items="filter.filterItems"
      :label="filter.filterLabel || filter.text"
      chips
      deletable-chips
      multiple
      dense
      outlined
    > 
      <template v-slot:prepend-item>
        <v-list-item
          ripple
          @click="selectAll(filter)"
        >
          <v-list-item-action class="my-0">
            <v-icon 
              v-if="filtersModels[filter.value] && filter.filterItems && filtersModels[filter.value].length > 0 && filtersModels[filter.value].length >= filter.filterItems.length" 
              :color="filtersModels[filter.value] && filtersModels[filter.value].length > 0 ? 'indigo' : ''">
              mdi-close-box
            </v-icon>
            <v-icon 
              v-else-if="filtersModels[filter.value] && filter.filterItems && filtersModels[filter.value].length > 0 && filtersModels[filter.value].length < filter.filterItems.length" 
              :color="filtersModels[filter.value] && filtersModels[filter.value].length > 0 ? 'indigo' : ''">
              mdi-minus-box
            </v-icon>
            <v-icon
              v-else
              :color="filtersModels[filter.value] && filtersModels[filter.value].length > 0 ? 'indigo' : ''"
              >
              mdi-checkbox-blank-outline
            </v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="text-uppercase">
              Selecionar Todos
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="mt-2"></v-divider>
      </template>
      <template v-slot:item="{ item, on, attrs }">
        <v-list-item v-bind="attrs" v-on="on">
          <v-list-item-action class="my-0">
            <v-icon 
              v-if="filtersModels[filter.value] && filtersModels[filter.value].includes(item)" 
              color="primary">
              mdi-checkbox-marked
            </v-icon>
            <v-icon v-else>mdi-checkbox-blank-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title v-text="item" class="text-uppercase">
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
      <template v-slot:selection="{ item, index }">
        <v-chip v-if="index === 0">
          <span>{{ item }}</span>
        </v-chip>
        <span v-if="index === 1" class="grey--text caption">
          (+{{ filtersModels[filter.value].length - 1 }} others)
        </span>
      </template>
    </v-select>
  </v-col>
</v-row>
</template>

<script>
export default {
  props: ['filters', 'filtersModels', 'search'],
  methods: {
    selectAll ({ filterItems, value }) {
      if ( !filterItems || !value )
        return

      if (!this.filtersModels[value] || this.filtersModels[value].length == 0) {
        this.$set(this.filtersModels, value, [...filterItems]) 
      } else {
        this.filtersModels[value].splice(0)
      }
    },

    clearFilters({invalidCells = false}) {
      this.search.value = ''
      Object.entries(this.filtersModels).forEach(([key,val]) => {
        if (typeof val == 'boolean')
          this.filtersModels[key] = false
        else if (Array.isArray(val))
          this.filtersModels[key].splice(0)
        else
          console.warn('unknown filter type', key, val)
      })
      this.filtersModels['invalidCells'] = invalidCells
    },
  }
}
</script>